import React from 'react';
import PropTypes from 'prop-types';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ApiFilter from './components/Provider';
import Container from './container';

const App = ({
  standalone,
  otherProps = {},
}) => (
  <Router>
    <ApiFilter
      appSessionId={otherProps?.appSessionId}
      endpoint={otherProps?.apiEndpoint}
      jwt={otherProps?.jwt}
      render={(handlers) => (
        <Container
          handlers={handlers}
          standalone={standalone}
          otherProps={otherProps}
        />
      )}
    />
  </Router>
);

App.propTypes = {
  standalone: PropTypes.bool,
  otherProps: PropTypes.object,
};

export default App;
